/// <reference path="../include.ts" />

namespace project_guide {

	import View = alm.view.View;
	import Spot = project_common.Spot;
	import Application = project_common.Application;
	import DomUtil = project_common.DomUtil;

	export class Header extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super(jQuery('#header'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.spotImage = view.find('.spot img');
			this.languageSelector = new LanguageSelector(view.find('.language-selector'));

			// reset
			this.clearContext();

			return view;
		}

		protected implReady():void {
			this.languageSelector.ready();
		}

		protected implFinalize():void {
			this.languageSelector.finalize();
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.languageSelector.show(useTransition);
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				this.languageSelector.hide(useTransition);
			});
		}





		public clearContext():void {
			DomUtil.clearImageFromSrc(this.spotImage);
			this.languageSelector.clearContext();
		}

		public setContext():void {
			this.clearContext();
			const spot = Application.getSpotData();

			DomUtil.loadImageToSrc(this.spotImage, spot.logoImage);
			this.languageSelector.setContext();
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		public static getInstance():Header { return this.instance || (this.instance = new Header()) };
		private static instance:Header = null;

		private spotImage:JQuery;
		private languageSelector:LanguageSelector;
	}
}
